import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { Col, Container, Row, Spinner } from 'react-bootstrap';
import Layout from '../../wrappers/layout';
import IndicatorCard from './components/indicator-card';
import BuySellMetals from './components/buy-sell-metals';
import DashboardBanner from './components/dashboard-banner';
import PageHeader from '../../shared/page-header';
import { dashboardStore } from '../../store/DashboardStore';
import { userStore } from '../../store/UserStore';
import DashboardService from '../../services/dashboard.service';
import RealisedService from '../../services/realised.service';
import Loader from '../../shared/common/loader';
import Banner from '../../assets/images/banner.png';
import { formatAmount } from '../../utils';
import NomineeModal from 'pages/profile/components/NomineeModal';
import Pushnotification from '../login/services/login.service';
import { getMessaging, getToken } from 'firebase/messaging';
import { app, db, auth } from '../../firebaseConfig';
import RedeemGiftModal from 'pages/gift-module/RedeemGiftModal';
import { useHistory, useLocation } from 'react-router-dom';
import SupportButton from 'shared/common/supportButton/SupportButton';
import { toast } from 'react-toastify';
import giftService from 'pages/gift-module/services/gift.service';
import KycFraudModal from 'shared/common/modal/kycFraudModal';
import GiftModal from 'pages/Corporate-gifting/GiftModal';
import SuccessGiftModal from 'pages/Corporate-gifting/SuccessGiftModal';
import { userTrackFunction } from 'utils/handleUtmParams';
import GainLossTable from './components/Gainlosstable';
import BankDetailsModal from './components/BankDetailsModal';
import './index.css';

const metalsWithCode = [
  { code: 'Au', name: 'Gold' },
  { code: 'Ag', name: 'Silver' },
  { code: 'Pt', name: 'Platinum' },
  { code: 'Pd', name: 'Palladium' },
];

const images = [
  { src: Banner, alt: 'Banner1' },
  // { src: Banner2, alt: "Banner2" },
  // Add more images as needed
];

interface PropsType { }

const DashboardPage: React.FC<PropsType> = () => {
  const renderCheck = useRef(false);
  // eslint-disable-next-line
  const [
    customerHolding,
    wallet,
    summary,
    accountsHolding,
    metals,
    setCustomerHolding,
    setAccountHolding,
    setWallet,
    setSummary,
    setMetals,
  ] = dashboardStore((state: any) => [
    state.customerHolding,
    state.wallet,
    state.summary,
    state.accountsHolding,
    state.metals,
    state.setCustomerHolding,
    state.setAccountHolding,
    state.setWallet,
    state.setSummary,
    state.setMetals,
  ]);
  const [customerId, user, selectedAccount, customer, tokens] = userStore(
    (state: any) => [
      state.customerId,
      state.user,
      state.selectedAccount,
      state.customer,
      state.tokens,
    ]
  );

  // const metalObj = ['Ag', 'Pd', 'Pt', 'Au'];
  const [loading, setLoading] = useState<boolean>(false);
  const [realisedLoading, setRealisedLoading] = useState<boolean>(false);
  const [holdings, setHoldings] = useState([]);
  const [open, setOpen] = useState<any>(false);
  const [realisedData, setRealisedData] = useState<any>();
  const [unRealisedData, setUnRealisedData] = useState<any>();
  const [showBankDetailsModal, setShowBankDetailsModal] = useState(false);
  const history = useHistory();
  const searchParams = new URLSearchParams(window.location.search);
  const gift = searchParams.get('gift');
  const [customerInvestedValue, setCustomerInvestedValue] = useState(0);

  // Corporate Gifting
  const [showCorpGiftModal, setShowCorpGiftModal] = useState(false);
  const [showCorpSuccessModal, setShowCorpSuccessModal] = useState(false);
  const [voucherCode, setVoucherCode] = useState('');
  const [corpGiftMessage, setCorpGiftMessage] = useState('');


  const [prefillConfig, setPrefillConfig] = useState<{
    action?: string;       // 'buy' | 'sell' | 'multimetal'
    by?: string;           // 'rupees' | 'grams'
    amt?: string;
    dist?: string;         // 'Au,Ag,Pt,Pd' comma-separated amounts
    metal?: string;        // 'Au' | 'Ag' etc.
    sip?: string;          // '1'
    sipint?: string;       // 'monthly'
  } | null>(null);


  const isValidGiftCode = async (code: any) => {
    try {
      const data = {
        voucherCode: code,
      };
      const res = await giftService.isValidGiftCode(data);
      console.log(res.data.data.GiftMessage);
      setCorpGiftMessage(res.data.data.GiftMessage);
      if (res.data.data.isValid) {
        setShowCorpGiftModal(true);
      } else {
        toast.error('Invalid Voucher Code!');
      }
    } catch (err) {
      toast.error('Something went wrong');
      console.log(err);
    }
  };

  const claimCorporateGift = async () => {
    try {
      const data = {
        corpVoucherId: voucherCode,
        partnerId: customer?.partner?.id,
      };
      setLoading(true);
      const res = await giftService.acceptCorporateGift(data);
      if (res.status == 201 && res.data.data.message == 'success') {
        setLoading(false);
        setShowCorpGiftModal(false);
        toast.success('Gift Claimed Successfully!');
        setShowCorpSuccessModal(true);
        getPassbookSummary();
      } else {
        setLoading(false);
        toast.error('Something went wrong!');
        setShowCorpGiftModal(false);
      }
    } catch (err: any) {
      console.log(err);
      setLoading(false);
      toast.error('Invalid Voucher Code');
      setShowCorpGiftModal(false);
    }
  };

  const redirectToPassbook = () => {
    history.push('/buy-sell');
  };

  const closeGiftModal = () => {
    setShowCorpGiftModal(false);
  };
  const closeGiftSuccessModal = () => {
    setShowCorpSuccessModal(false);
  };
  // end Corporate Gifting

  // KYC for fraud
  const location: any = useLocation();
  const [isKycFRequired, setIsKycFRequired] = useState(false);
  const [kycError, setKycError] = useState('');

  const metalFromDeepLink = (location.state as any)?.metal ?? null;


  useEffect(() => {
    const isKycRequiredDash = location.state?.isKycRequired || false;
    const KycErrorDash = location.state?.kycError || '';
    if (isKycRequiredDash) {
      setIsKycFRequired(true);
      setKycError(KycErrorDash);
    }
  }, []);

  const KycFraudCompleteFunction = async () => {
    try {
      const res = await DashboardService.isKYCFraudComplete();
      if (!res?.data?.kyc_completed) {
        // Adjust based on actual response structure
        setIsKycFRequired(true);
        setKycError(res?.data?.kyc_error);
        return true;
      } else {
        return false;
      }
    } catch (error) {
      console.error(error);
      toast.error('Something went wrong');
    }
  };

  const images = [
    { src: Banner, alt: 'Banner' },
  ];

  const ecom = searchParams.get('ecom');
  const decodedecom = ecom ? JSON.parse(decodeURIComponent(ecom)) : null;
  // const decodedMetal = gift ? decodeURIComponent(gift) : ((decodedecom ? decodedecom.metalType) : undefined);
  const decodedMetal = gift
    ? decodeURIComponent(gift)
    : decodedecom
      ? decodedecom.metalType
      : undefined;
  useEffect(() => {
    if (selectedAccount) {
      let acHoldings = accountsHolding.find(
        (acc) => acc.accountId === selectedAccount.accountId
      );
      if (acHoldings) setHoldings(acHoldings.accountHolding);
    }
  }, [accountsHolding, selectedAccount]);

  useEffect((): any => {
    getPassbookSummary();
    getAllMetals();
    getCustomerHoldings();
    storeFCMToken();
    document.title = 'Dashboard - eBullion';
  }, []);

  useEffect(() => {
    if (renderCheck.current) {
      getPassbookSummary();
      getAllMetals();
    } else {
      renderCheck.current = true;
    }
  }, [customerId]);

  const handleBannerClick = () => {
    history.push('/sip');
  };

  /**
   * Get passbook summary details
   */
  const getPassbookSummary = async () => {
    setLoading(true);
    try {
      const res: any = await DashboardService.getPassbookSummary(
        customerId,
        user?.userId
      );
      if (res.status === 200 && res.data.data) {
        setCustomerHolding(
          res.data.data.metal.customerHolding.sort((a: any, b: any) =>
            a.metal.localeCompare(b.metal)
          )
        );
        setAccountHolding(res.data.data.metal.accountsHolding);
        setWallet(res.data.data.wallet);
        setSummary(res.data.data.summary);

        setLoading(false);
      }
    } catch (e: any) {
      setLoading(false);
    }
  };

  /**
   * Get all metals
   */
  const getAllMetals = async () => {
    setLoading(true);
    try {
      const res: any = await DashboardService.getAllMetals();
      if (res.status === 200 && res.data.data.result.length > 0) {
        setMetals(res.data.data.result);
        setLoading(false);
      }
    } catch (e: any) {
      setLoading(false);
    }
  };

  const getCustomerHoldings = async() =>{
    setLoading(true);
    try {
      const payload = {
        customerId: customerId,
        partnerId: customer?.partner?.id,
      }
      const res = await DashboardService.getInvestmentValue(payload);
      setCustomerInvestedValue(res?.data?.data?.totalInvestmentAmount);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.error("Something went worng!");
    }
  }

  const storeFCMToken = async () => {
    try {
      const messaging = getMessaging(app);
      const userId = user?.customers[0]?.user?.userId;

      // Retrieve the FCM token
      getToken(messaging)
        .then(async (token) => {
          const data = { webtoken: token, user_id: userId };
          const storeToken = await Pushnotification.storeFcmToken(data);
          // console.log('FCM Token:', token);
        })
        .catch((error) => {
          console.error('Error getting FCM token:', error);
        });
    } catch (err) {
      console.log(err);
    }
  };

  const claimGift = () => {
    history.push('/gift?giftListReceived=true');
  };
  const onCancel = () => {
    localStorage.setItem('popupGiftShown', 'true');

    setOpen(false);
  };

  // realised data
  const profitLoss = async () => {
    try {
      const data = { customerId: customerId };
      setRealisedLoading(true);
      const res = await RealisedService.realisedData(
        data,
        user?.userId,
        user?.partner?.id
      );
      if (res.status == 200) {
        const newdata: Object = res.data.data.Realised;
        // arrayOfObjects = Object.entries(newdata).map(([key, value]) => ({
        //   metal: key,
        //   ...value,
        // }));
        setRealisedData(res?.data?.data?.Realised);
        setUnRealisedData(res?.data?.data?.Unrealised);
        setRealisedLoading(false);

        // console.log('realiseddata', arrayOfObjects);
      } else {
        // setRealisedLoading(false);

        toast.error('Something went wrong');
      }
    } catch (err) {
      console.log(err);
      setRealisedLoading(false);

      toast.error('Something went wrong');
    }
  };
  useEffect(() => {
    profitLoss();
    const hasPopupBeenShown = localStorage.getItem('popupGiftShown');
    if (
      !hasPopupBeenShown &&
      customer?.giftCount > 0 &&
      customer?.customerCategory === 'UNREGISTERED'
    ) {
      setOpen(true);
      localStorage.setItem('popupGiftShown', 'true');
    }
  }, []);

  useEffect(() => {
    const sipLSdata = localStorage.getItem('sipdata');
    if (sipLSdata !== null) {
      history.push({
        pathname: '/sip',
        state: { sipdata: JSON.parse(sipLSdata) },
      });
    }

    const manualSipLSdata = localStorage.getItem('manualSipData');
    if (manualSipLSdata !== null) {
      const manualSipObj = JSON.parse(manualSipLSdata);
      const manualSipEncObj = encodeURIComponent(manualSipLSdata);

      let redirectUrl = `/sip-payment-schedule/${manualSipObj?.sipId}?data=${manualSipEncObj}`;
      history.push(redirectUrl);
    }
  }, []);

  useEffect(() => {
    const corpGiftVoucher = localStorage.getItem('corpVoucherCode');
    if (corpGiftVoucher) {
      isValidGiftCode(corpGiftVoucher);
      setVoucherCode(corpGiftVoucher);
      localStorage.removeItem('corpVoucherCode');
    }

    const utmParams = localStorage.getItem('utmData');
    const buyMethod = JSON.parse(localStorage.getItem('buyMethod'));

    if (utmParams) {
      userTrackFunction(user?.userId, '', buyMethod);
      localStorage.removeItem('utmData');
    }
  }, []);

  useEffect(() => {

    const params = new URLSearchParams(location.search);

    const method = params.get('method');
    const metal = params.get('metal');
    const amt = params.get('amt');
    const stg = params.get('stg');
    const dist = params.get('dist');

    if (!method) return;

    const parsedAmt = amt ? parseInt(amt, 10) : 100;
    const parsedDist = dist ? dist.split(',').map(Number) : undefined;

    const sipInterval: 'daily' | 'weekly' | 'monthly' =
      method === 'd_sip' ? 'daily' :
        method === 'w_sip' ? 'weekly' :
          'monthly';

    switch (method) {
      case 'd_sip':
      case 'w_sip':
      case 'm_sip': {
        let route = '/sip';
        let allocationMode = undefined;         // ← added

        if (stg === '2') {
          route = '/daily-saving';
          allocationMode = 'goldSilver';        // ← added
        } else if (stg === '3') {
          route = '/multimetal-sip';
          allocationMode = 'multi';             // ← added
        }

        history.push(route, {
          sipdata: {
            sipAmount: parsedAmt,
            sipInterval,
            sipMetalType: metal ?? undefined,
            allocationMode,
            dist: parsedDist,
          },
        });

        break;
      }

      case 'buy_metal':
        history.push('/dashboard', { metal: metal ?? undefined });
        break;

      case 'shop':
        history.push('/buy-coins-bars');
        break;
    }
  }, []);

  useEffect(() => {
    if (loading) return;

    const isBankDetailsMissing =
      !customer?.bankDetails?.accountNo ||
      customer?.bankDetails?.state !== 'VERIFIED';

    const hasSignificantHoldings = summary?.metalBalance > 100;

    if (isBankDetailsMissing && hasSignificantHoldings) {
      const timer = setTimeout(() => {
        setShowBankDetailsModal(true);
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [loading, summary?.metalBalance, customer?.bankDetails]);


  useEffect(() => {
    // ── Scenario B: came via login flow, params saved to localStorage ──────
    const raw = localStorage.getItem('prefillParams');
    if (raw) {
      try {
        const params = JSON.parse(raw);
        setPrefillConfig(params);
      } catch {
        // ignore malformed
      } finally {
        localStorage.removeItem('prefillParams');
      }
      return; // localStorage takes priority, stop here
    }

    // ── Scenario A: user was already logged in, redirected with search params
    // still on the URL e.g. /dashboard?action=multimetal&dist=1000,1000,500,0
    const urlParams = new URLSearchParams(window.location.search);
    const action = urlParams.get('action');
    const method = urlParams.get('method');
    const by = urlParams.get('by');
    const amt = urlParams.get('amt');
    const dist = urlParams.get('dist');
    const metal = urlParams.get('metal');
    const sip = urlParams.get('sip');
    const sipint = urlParams.get('sipint');

     const resolvedAction = action ?? (method === 'BMM' ? 'multimetal' : undefined);


    if (resolvedAction || sip) {
      setPrefillConfig({ action, by, amt, dist, metal, sip, sipint });

      // Clean the URL so params don't linger or re-trigger on refresh
      const cleanUrl = window.location.pathname;
      window.history.replaceState({}, '', cleanUrl);
    }
  }, []);

  return (
    <Layout>
      {loading ? (
        <Loader />
      ) : (
        <div>
          {/*<Toast/>*/}
          <PageHeader
            mainTitle={user.displayName}
            subTitle='Below are your total holdings'
          />

          <Row>
            <Col md={8}>
              <Row>
                <Col md={6}>
                  <div className='my-1 col col-sm-12 '>
                    <IndicatorCard
                      isMain
                      heading={
                        <span className='metal-heading'>
                          Your Invested Value
                          <span className='metal-note'>
                            *(Exclusive of GST)
                          </span>
                        </span>
                      }
                      amount={`₹ ${formatAmount(customerInvestedValue) || '0.00'
                        }`}
                      backgroundColor='#301250'
                      addClassName='py-2 tot-card'
                      styles=''
                    />
                  </div>
                </Col>
                <Col md={6}>
                  <div className='my-1 col col-sm-12 '>
                    <IndicatorCard
                      isMain
                      heading='In Wallet'
                      amount={`₹ ${formatAmount(wallet.balance)}` || '0.00'}
                      styles=''
                      addClassName='wallet '
                      earmarkedBalance={`₹ ${formatAmount(wallet.lockBalance)}`}
                    />
                  </div>
                </Col>
              </Row>

              <div className='col-md-8 overflow-auto d-sm-block d-md-none'>
                <div className='d-flex flex-column bd-highlight'>
                  {holdings?.map((account: any, index: number) => (
                    <div key={index} className='mb-2 flex-fill flex-shrink-0'>
                      <div key={index} className=''>
                        <IndicatorCard
                          // eslint-disable-next-line react/no-array-index-key
                          isMain={false}
                          heading={
                            metalsWithCode.filter(
                              (x: any) => x.code === account.metal
                            ).length > 0
                              ? metalsWithCode.filter(
                                (x: any) => x.code === account.metal
                              )[0].name
                              : ''
                          }
                          amount={`₹ ${formatAmount(account.value) || ' 0.00'}`}
                          quantity={`${account.quantity?.toFixed(4)}`}
                          addClassName={`${account.metal} metal mobileCard`}
                          earmarkedBalance={account.lockQuantity || ''}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className='d-md-grid grid d-sm-flex mt-2 d-none d-sm-block'>
                {holdings?.map((account: any, index: number) => (
                  <div key={index}>
                    <IndicatorCard
                      // eslint-disable-next-line react/no-array-index-key
                      isMain={false}
                      heading={
                        metalsWithCode.filter(
                          (x: any) => x.code === account.metal
                        ).length > 0
                          ? metalsWithCode.filter(
                            (x: any) => x.code === account.metal
                          )[0].name
                          : ''
                      }
                      metalCode={account.metal}
                      redirectLink={`/passbook?metalCode=${account.metal}`}
                      amount={`₹ ${formatAmount(account.value) || ' 0.00'}`}
                      quantity={`${account.quantity?.toFixed(4)}`}
                      addClassName={`${account.metal} metal`}
                      earmarkedBalance={account.lockQuantity || ''}
                    />
                  </div>
                ))}
                {customerHolding && customerHolding.length === 0 ? (
                  <>
                    {[1, 2, 3, 4].map((item: any, index: number) => (
                      <div key={index}>
                        <IndicatorCard
                          // eslint-disable-next-line react/no-array-index-key
                          isMain={false}
                          heading={null}
                          amount={null}
                          quantity={null}
                          addClassName={` metal`}
                          earmarkedBalance={null}
                        />
                      </div>
                    ))}
                  </>
                ) : (
                  <></>
                )}
              </div>
              <DashboardBanner images={images} onClick={handleBannerClick} />
            </Col>
            <Col md={4}>
              <BuySellMetals
                metals={metals}
                walletBalance={summary.walletBalance}
                isDashboard={true}
                getPassbookSummary={getPassbookSummary}
                giftMetal={decodedMetal}
                KycFraudCompleteFunction={KycFraudCompleteFunction}
                preselectedMetal={metalFromDeepLink}
                prefillConfig={prefillConfig}
              />
            </Col>
          </Row>
          <SupportButton />


          <GainLossTable
            realisedData={realisedData}
            unRealisedData={unRealisedData}
            realisedLoading={realisedLoading}
          />

          {/* <SupportButton /> */}
        </div>
      )}

      {customer.giftCount > 0 &&
        customer?.customerCategory === 'UNREGISTERED' &&
        !showCorpGiftModal &&
        !showCorpSuccessModal && (
          <RedeemGiftModal
            showModal={open}
            closeModal={() => {
              setOpen(false);
              closeGiftModal();
            }}
            proceed={claimGift}
            cancel={onCancel}
            text={`
        You have received a gift🎁
        To claim it, please go to Gift Page.
        Thank you!
      `}
            keytext={'gift'}
            okButton={'Go to Gift'}
            cancelButton={'Later'}
            title={'Your Gift Awaits!'}
          />
        )}

      {/* <NomineeModal /> */}

      <GiftModal
        showModal={showCorpGiftModal}
        closeModal={() => {
          closeGiftModal(); // Close GiftModal
          setOpen(false); // Ensure RedeemGiftModal stays closed
        }}
        cancel={closeGiftModal}
        proceed={claimCorporateGift}
        corpGiftMessage={corpGiftMessage}
      />

      <SuccessGiftModal
        showModal={showCorpSuccessModal}
        cancel={() => {
          closeGiftSuccessModal();
          setOpen(false);
        }}
        proceed={redirectToPassbook}
      />
      <KycFraudModal
        showModal={isKycFRequired}
        closeModal={() => {
          setIsKycFRequired(false);
        }}
        text={kycError}
        title={'KYC Required!'}
      />

      <BankDetailsModal
        show={showBankDetailsModal}
        onClose={() => setShowBankDetailsModal(false)}
      />
    </Layout>
  );
};

export default DashboardPage;
